<template>
  <div id="page-product-details">
    <distribution-list-form
        v-model="model"
        :facility-id="$route.params.id"
        ref="form"
        :disallowed-report-types="usedReportTypes"
        :loading="loading"
        :card-title="cardTitle"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              class="my-4"
              @click="back()"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              class="my-4"
              color="light"
              @click="save"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import DistributionListForm from '@/views/pages/facilities/distribution-lists/DistributionListForm';
import CanAccessMixin from "../../../../components/mixins/CanAccessMixin";

export default {
  name: "DistributionListEdit",
  components: {
    DistributionListForm,
  },
  mixins: [ViewModelMixin, SaveModelMixin, NotificationMixin, CanAccessMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.facilities.distributionLists,
      componentAccess: {
        canDelete: {
          route: 'facilities.distribution-lists.delete',
          access: false,
        },
      },
      entity: 'Distribution List',
      usedReportTypes: [],
    };
  },
  computed: {
    cardTitle() {
      if (this.model.id) {
        return `FDO #${this.model.FDO_FK}`;
      }

      return '';
    },
    id() {
      return this.$route.params.distributionListId;
    },
  },
  async mounted() {
    await this.fetch(this.id);
    this.getUsedReportTypes();
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);
      this.setReferences(['FacilityReportType_FK']);
      delete params.Facility_FK;

      return params;
    },
    async getUsedReportTypes() {
      try {
        const { data } = await this.$api.facilities.underwriters.relationship('distribution-lists', this.model.FDO_FK);
        this.usedReportTypes = data.data.map(({Type_PK}) => parseInt(Type_PK));
      } catch(e) {
        console.log(e);
      }
    },
    postSave() {
      this.back();
    },
    back() {
      this.$router.push({ name: 'facilities.distribution-lists.view' });
    },
    deleteList() {
      const deleteRecord = async () => {
        try {
          await this.$api.facilities.distributionLists.delete(this.id);
          await this.$router.back()
        } catch(e) {
          console.log(e);
        }
      }

      const message = "Warning: this operation is not reversible. Please confirm deletion of this role. "
          + "Are you sure you want to delete this list?";

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: message,
        accept: deleteRecord,
        acceptText: 'Delete'
      })
    }
  },
};
</script>

<style scoped>

</style>
